import { useEffect, useRef } from "react";
import gsap from "gsap";
import { GOALS } from "@/constants/data";
import { SelectionCard } from "@/components/SelectionCard";
import { StickyCTA } from "@/components/StickyCTA";

export const GoalsScreen = ({ selected, onToggle, onContinue }) => {
  const headerRef = useRef(null);
  const gridRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const ctx = gsap.context(() => {
      gsap.from(headerRef.current?.children || [], {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.07,
      });
      gsap.from(gridRef.current?.children || [], {
        opacity: 0,
        y: 24,
        scale: 0.98,
        duration: 0.55,
        ease: "power3.out",
        stagger: 0.05,
        delay: 0.15,
      });
    });
    return () => ctx.revert();
  }, []);

  const isSelected = (id) => selected.some((g) => g.id === id);

  return (
    <section className="min-h-[calc(100vh-100px)] pt-4 md:pt-6 pb-8 md:pb-10 px-6 md:px-10 lg:px-16 2xl:px-24 max-w-7xl 3xl:max-w-[1600px] mx-auto flex flex-col">
      <div ref={headerRef} className="text-center mb-6 md:mb-8">
        <p className="text-xs tracking-[0.24em] uppercase text-zinc-500 dark:text-zinc-500 font-semibold mb-2">
          Step 01 — Vision
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl 3xl:text-7xl font-medium tracking-tighter text-zinc-900 dark:text-zinc-50 leading-[1.05] font-display">
          What does your dream{" "}
          <span className="text-brand uppercase italic"> retirement life &nbsp;</span>
          look like?
        </h1>
        <p className="text-sm md:text-base 2xl:text-lg text-zinc-600 dark:text-zinc-400 mt-2.5 max-w-2xl mx-auto">
          Pick everything that resonates. We&apos;ll quietly do the math behind it.
        </p>
      </div>

      <div
        ref={gridRef}
        className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5 flex-1 content-start auto-rows-fr"
      >
        {GOALS.map((goal, i) => (
          <SelectionCard
            key={goal.id}
            testId={`goal-card-${goal.id}`}
            image={goal.image}
            title={goal.label}
            subtitle={goal.sub}
            hint={goal.accent}
            selected={isSelected(goal.id)}
            onClick={() => onToggle(goal)}
            index={i}
          />
        ))}
      </div>

      <StickyCTA
        label={selected.length === 0 ? "Pick at least one" : "Continue"}
        disabled={selected.length === 0}
        onClick={onContinue}
        helper={""}
      />
    </section>
  );
};
